(() => {
  const drawer = document.querySelector('[data-bcos-filters-drawer]');
  const toggle = document.querySelector('[data-bcos-filters-toggle]');
  if (!drawer || !toggle) return;

  const body = document.body;
  let lastFocused = null;

  function getFocusable() {
    return [...drawer.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )].filter((el) => el.offsetParent !== null);
  }

  function isOpen() {
    return drawer.getAttribute('data-open') === 'true';
  }

  function trapFocus(event) {
    const focusable = getFocusable();
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function open() {
    lastFocused = document.activeElement;
    drawer.setAttribute('data-open', 'true');
    toggle.setAttribute('aria-expanded', 'true');
    body.classList.add('bcos-scroll-lock');
    const target = drawer.querySelector('input, select, button');
    if (target) target.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function close() {
    drawer.setAttribute('data-open', 'false');
    toggle.setAttribute('aria-expanded', 'false');
    body.classList.remove('bcos-scroll-lock');
    document.removeEventListener('keydown', onKeydown);
    if (lastFocused && lastFocused.isConnected) lastFocused.focus();
  }

  function onKeydown(event) {
    if (event.key === 'Escape') close();
    if (event.key === 'Tab') trapFocus(event);
  }

  toggle.addEventListener('click', () => {
    isOpen() ? close() : open();
  });

  document.querySelectorAll('[data-bcos-filters-close]').forEach((el) => {
    el.addEventListener('click', close);
  });
})();
